namespace TerminalApp {

    export class RefundBundleParent {
        refundBundleBalanceLine: SP.RefundBundleBalanceLine;
        maxBalance: number;
        currentBalance: number;
        children: RefundBundleChild[] = [];

        constructor(refundBundleBalanceLine: SP.RefundBundleBalanceLine) {
            this.refundBundleBalanceLine = refundBundleBalanceLine;
            this.maxBalance = refundBundleBalanceLine.balance;
        }

        updateAllChildrenBalance() {
            let currentBalance = this.maxBalance;
            for (var i = 0; i < this.children.length; i++) {

                let thisInputValue = this.children[i].input.value;
                if (thisInputValue.length == 0) {
                    thisInputValue = "0";
                }

                currentBalance -= parseFloat(thisInputValue);
                this.currentBalance = currentBalance;
            }

            for (var i = 0; i < this.children.length; i++) {
                this.children[i].balanceContainer.innerHTML = currentBalance.toString();
            }
        }

        addChild(refundBundleChild: RefundBundleChild) {
            this.children.push(refundBundleChild);
        }
    }


    export class RefundBundleChild {
        container: HTMLElement = document.createElement("div");
        parent: RefundBundleParent;
        input: HTMLInputElement;
        balanceContainer: HTMLElement;
        warningSpan: HTMLElement;

        updatedLine: SP.UpdatedRefundLine;

        constructor(refundLine: SP.RefundLineInfo, parent: RefundBundleParent, updatedLine: SP.UpdatedRefundLine) {
            this.parent = parent;
            this.updatedLine = updatedLine;

            this.container.innerHTML = `

                <div class="returnRefund-item-overall-container" style="width: 97%; margin: 0 auto 20px auto;">

                        <div class="returnRefund-item-container">
                            <div class="returnRefund-itemImage-container">
                                <img class="returnRefund-itemImage" src="${refundLine.orderLine.imageUrl}">
                            </div>
                            <div class="returnRefund-itemInfo-container">

                                <span class="return-lineInfo-name" style="font-weight: 600; font-size: 18px;">${refundLine.orderLine.description}</span>

                                <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;">
                                    <span class="returnRefund-itemInfo-quantity"><b>${SP.Localize("word_quantity")}: ${refundLine.qty}</b></span>
                                </div>
                                    
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;">
                                    <span class="returnRefund-itemInfo-balance"><b>${SP.Localize("word_balance")}: <span class="returnRefund-itemInfo-balance-span">${parent.refundBundleBalanceLine.balance}<span></b></span>
                                </div>
                            </div>
                        </div>
                
                    <div class="returnRefund-footer-container" style="display: block !important;">
                        <input class="refundBundleInput" type="number" step="any" placeholder="0.00" value="${this.updatedLine.price}" />
                        <span class="refundBundleInput-warning" style="display: none; color: red; font-size: 21px !important; padding: 5px 0 0 0 !important;">Price is bigger than balance</span>
                    </div>

                </div>

            `;

            this.input = this.container.querySelector(".refundBundleInput") as HTMLInputElement;
            this.balanceContainer = this.container.querySelector(".returnRefund-itemInfo-balance-span") as HTMLElement;
            this.warningSpan = this.container.querySelector(".refundBundleInput-warning") as HTMLElement;

            this.input.addEventListener("input", (event) => {
                let thisTarget = event.target as HTMLInputElement;

                let inputValue = thisTarget.value;
                if (thisTarget.value.length == 0) {
                    inputValue = "0";
                }

                this.updatedLine.price = parseFloat(inputValue);
                this.parent.updateAllChildrenBalance();
            });
        }
    }


    export class RefundBundleAssistant extends Assistant {
        static instance: App_Return;

        main_container: HTMLElement;

        refundInfo: SP.RefundInfo;
        refundLines: SP.UpdatedRefundLine[];
        updatedLines: SP.UpdatedRefundLine[];
        refundBundleBalanceLines: SP.RefundBundleBalanceLine[];

        refundParents: { [id: string]: RefundBundleParent } = {};

        callback: (updatedRefundLines: SP.UpdatedRefundLine[]) => void;

        constructor() {
            super();
            this.container.classList.add("assistant");

            this.refundLines = [];         

            this.container.addEventListener("click", (event) => {
                let thisTarget = event.target as HTMLElement;

                this.refundLines = [];

                if (thisTarget.classList.contains("refundBundle-confirm-btn")) {

                    let balanceIsNegative = false;

                    for (let key in this.refundParents) {
                        let thisParent = this.refundParents[key];

                        let thisParentBalanceIsNegative = false;;

                        if (thisParent.currentBalance < 0) {
                            balanceIsNegative = true;
                            thisParentBalanceIsNegative = true;
                        }

                        thisParent.children.forEach((child) => {

                            if (thisParentBalanceIsNegative) {
                                child.warningSpan.style.display = "block";
                            }

                            if (!balanceIsNegative) {
                                this.refundLines.push(child.updatedLine);
                            }
                        });
                    }

                    if (balanceIsNegative) {
                        return;
                    }

                    if (this.callback) {
                        this.callback(this.refundLines);
                    }

                    this.close();
                    return;
                }
            });
        }

        initialize() {
            this.main_container = document.createElement("div");
            this.main_container.style.marginTop = "80px";

            this.refundBundleBalanceLines.forEach(d => {
                this.refundParents[d.orderLineId] = new RefundBundleParent(d);
            });

            let updatedLinesIsEmpty = true;
            if (this.updatedLines.length != 0) {
                updatedLinesIsEmpty = false;
            }

            for (var i = 0; i < this.refundInfo.lines.length; i++) {
                let line = this.refundInfo.lines[i];

                if (line.orderLine.bundleParent == null || line.orderLine.bundleParent == "") {
                    continue
                }

                if (updatedLinesIsEmpty) {
                    this.updatedLines.push({
                        refundId: this.refundInfo.refundId,
                        refundLineId: line.id,
                        price: 0,
                    });
                }

                let thisUpdatedLineIndex = this.updatedLines.findIndex((x) => x.refundLineId == line.id);

                let parent = this.refundParents[line.orderLine.bundleParent];
                if (parent) { 
                    let refundChild = new RefundBundleChild(line, parent, this.updatedLines[thisUpdatedLineIndex]);
                    parent.addChild(refundChild);
                    this.main_container.appendChild(refundChild.container);
                }

                parent.updateAllChildrenBalance();
            }

            var button = document.createElement("div");
            button.innerHTML = `<button class="refundBundle-confirm-btn grad-green">${SP.Localize("word_confirm")}</button>`;
            this.main_container.appendChild(button);
            this.container.appendChild(this.main_container);
        }


        async open(callback: (updatedRefundLines: SP.UpdatedRefundLine[]) => void, refundInfo: SP.RefundInfo, updatedLines: SP.UpdatedRefundLine[], refundBundleBalanceLines: SP.RefundBundleBalanceLine[]) {
            this.refundInfo = refundInfo;
            this.updatedLines = updatedLines;
            this.refundBundleBalanceLines = refundBundleBalanceLines;

            this.callback = callback;

            this.initialize();

            this.container.style.display = "block";
        }

        close() {
            super.close();
            this.clear();
        }

        clear() {
            this.main_container.innerHTML = "";
            this.refundInfo = null;
            this.refundLines = [];
            this.updatedLines = [];
            this.refundBundleBalanceLines = [];
            this.refundParents = {};
        }

    }
}